export default __webpack_public_path__ + "static/media/basket.68123eff.svg";